import { STATUS } from "@/constants/statuses";
import BaseStore from "@/stateManagement/BaseStore";
import { RewardsEarnPointsEntity } from "@apps/rewards/entities/entities";
import { StoreConfig } from "@datorama/akita";
import { injectable } from "tsyringe";

export interface RewardsEarnPointsState {
    rewardsEarnPoints: RewardsEarnPointsEntity | null;
}

const createInitialState = (): RewardsEarnPointsState => ({
    rewardsEarnPoints: null,
});

@injectable()
@StoreConfig({ name: "RewardsEarnPointsStore" })
class RewardsEarnPointsStore extends BaseStore<RewardsEarnPointsState> {
    constructor() {
        super(createInitialState());
    }

    setStatus(status: STATUS): void {
        this.update((state) => ({ ...state, status }));
    }
}

export default RewardsEarnPointsStore;
